import React from 'react';

const SlidingDrawer = ({ isOpen, onClose, title, children, contentClassName }) => {
    return (
        <>
            {/* Backdrop */}
            <div
                onClick={onClose}
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(44, 26, 16, 0.4)',
                    backdropFilter: 'blur(4px)',
                    zIndex: 1000,
                    opacity: isOpen ? 1 : 0,
                    visibility: isOpen ? 'visible' : 'hidden',
                    transition: 'all 0.4s ease'
                }}
            />

            {/* Drawer Panel */}
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    right: 0,
                    width: '600px',
                    height: '100%',
                    backgroundColor: '#fff',
                    zIndex: 1001,
                    boxShadow: '-10px 0 50px rgba(0,0,0,0.1)',
                    transform: isOpen ? 'translateX(0)' : 'translateX(100%)',
                    transition: 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                    display: 'flex',
                    flexDirection: 'column',
                    fontFamily: '"Outfit", sans-serif'
                }}
            >
                {/* Header */}
                <div style={{
                    padding: '30px 40px',
                    borderBottom: '1px solid #F0F0F0',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'linear-gradient(to right, #FDF8F3, #fff)',
                    position: 'relative'
                }}>
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '11px', color: '#C0722C', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '2px', marginBottom: '8px' }}>Registry Entry</div>
                        <h2 style={{ margin: 0, color: '#2C1A10', fontSize: '24px', fontWeight: '900' }}>{title}</h2>
                    </div>
                    <button
                        onClick={onClose}
                        style={{
                            position: 'absolute',
                            right: '30px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            width: '40px',
                            height: '40px',
                            borderRadius: '12px',
                            border: '1px solid #E0E0E0',
                            backgroundColor: '#fff',
                            color: '#666',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'all 0.2s ease',
                            zIndex: 10
                        }}
                        onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#2C1A10'; e.currentTarget.style.color = '#fff'; }}
                        onMouseOut={(e) => { e.currentTarget.style.backgroundColor = '#fff'; e.currentTarget.style.color = '#666'; }}
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
                    </button>
                </div>

                {/* Content */}
                <div className={contentClassName} style={{
                    flex: 1,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    padding: '40px',
                    msOverflowStyle: 'none',  /* IE and Edge */
                    scrollbarWidth: 'none',   /* Firefox */
                }}>
                    <style>
                        {`
                            .${contentClassName}::-webkit-scrollbar {
                                display: none;
                            }
                        `}
                    </style>
                    {children}
                </div>
            </div>
        </>
    );
};

export default SlidingDrawer;
